declare const THREE: any;

/**
 *@description
 * https://prnt.sc/qvlv6s
 * @param {any} handrail
 * @param {any} pos pos1 or pos2 (from post position)
 * @returns {any}
 * @function
 */
export const getHandrailLevelPosPoint = (handrail, pos) =>
  pos
    .clone()
    .setY(pos.y + handrail.userData.entity.placementHeight + handrail.userData.entity.height / 2);



// WEBPACK FOOTER //
// ./src/app/services/railing/utils/get-handrail-level-pos-point.ts